import { useStore } from 'effector-react';
import { queryString } from 'libs/query-string';
import { css } from 'linaria';
import { sendEvent } from 'model/helpers/events.model';
import { link$ } from 'model/flows/fallback.model';
import { screenHistoryPush, ScreenName } from 'model/helpers/screens-history';
import { useLocalization } from 'model/localization.model';
import { h } from 'preact';
import { styled } from 'linaria/react';
import { useEffect, useRef } from 'preact/hooks';

import { QRCode, QRErrorCorrectLevel } from 'libs/qrcode';
import { Container } from 'ui/container';
import { Spinner } from 'ui/spinner';
import { Subtitle, Text } from 'ui/typography';

const getCSSVariable = (name: string): string => {
	return getComputedStyle(document.querySelector('[data-verify-container]')).getPropertyValue(name);
};

export const LinkQrCodeView = () => {
	const t = useLocalization();
	const qr = useRef(null);
	const link = useStore(link$);

	useEffect(() => {
		if (link !== null) {
			new QRCode(qr.current, {
				data: link + '?q=' + btoa(queryString.encode({ f: 'qr' })),
				width: 125,
				height: 125,
				colorDark: getCSSVariable('--barcode-dark'),
				colorLight: getCSSVariable('--barcode-light'),
				correctLevel: QRErrorCorrectLevel.L,
			});
		}
	}, [qr, link]);

	useEffect(() => {
		screenHistoryPush(ScreenName.qr);
		setTimeout(() => {
			sendEvent({ event: 'qr_screen_shown' });
		}, 20);
	}, []);

	return (
		<Container>
			<Subtitle>{t('qr.title')}</Subtitle>
			<Text className={textClass}>{t('qr.description')}</Text>
			<QrCode
				ref={qr}
			>
				{link.length === 0 && (
					<Spinner
						size={32}
						fill={{
							primary: 'var(--primary-color)',
							secondary: 'var(--secondary-color)',
						}}
					/>
				)}
			</QrCode>
		</Container>
	);
};

const textClass = css`
  margin-bottom: 20px;
	min-height: 66px;
`;
const QrCode = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 143px;
  height: 143px;
  padding: 8px;
  margin: 0 auto 0;
  border: 1px solid var(--button-outline-border);
  border-radius: 4px;
  background: var(--barcode-light);
`;
